module.exports = __webpack_public_path__ + "static/media/img-4.7057d4b7.png";